export default {
  app: {
    languagePopup: {
      title: 'Šiuo metu naudojatės angliška {logo} versija',
      subtitle: 'Ar norite perjungti į pageidaujamą kalbą?',
      cta: 'Perjungti į {lang}',
    },
  },
};
